(function () {
  'use strict';



  var SHEET_URL = 'https://sheets.googleapis.com/v4/spreadsheets/1Zq8qshcFC7Wu6x--lLNZ1pVOX-WCAG4J__YCzR6vjY8/values/Salony?alt=json&key=AIzaSyDWKmI9JV5NFyOkvSoZ6n-KsEyklnYaLaQ';
  var GEO_TIMEOUT_MS   = 1500; // maks. czekanie na browsing_context_suggestions
  var CLUSTER_MAX_ZOOM = 11;   // od tego zoomu pinezki zawsze pojedynczo
  var CLUSTER_GRID_PX  = 72;   // rozmiar siatki klastrowania w pikselach mapy
  var PIN_W = 16, PIN_H = 34;  

  var ALL_LABELS = { pl: 'Wszystkie', de: 'Alle', en: 'All', fr: 'Tous', es: 'Todos', it: 'Tutti' };

  var root = document.querySelector('.stores-v2');
  if (!root) return;

  var menuEl  = root.querySelector('[data-finder-menu]');
  var listEl  = root.querySelector('[data-finder-list]');
  var infoEl  = root.querySelector('[data-finder-info]');
  var mapWrap = root.querySelector('.stores__map');
  var mapEl   = document.getElementById('map');
  if (!menuEl || !listEl || !mapEl) return;

  var locale = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  var ALL    = ALL_LABELS[locale] || 'All';

  function debounce(fn, ms) {
    var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function siteLabel(value) {
    var label = String(value || '').trim().replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/$/, '');
    return ['fr', 'es'].includes(locale) ? label.replace(/^mailto:/i, '') : label;
  }

  function siteHref(value) {
    if (locale === 'de') {
      var deHref = String(value || '');
      return /^www\.(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:[/?#][^\s]*)?$/i.test(deHref) ? 'https://' + deHref : deHref;
    }
    if (!['fr', 'es'].includes(locale)) return String(value || '');
    var href = String(value || '').trim();
    if (['fr', 'es'].includes(locale) && /^[^\s@:]+@[^\s@:]+\.[^\s@:]+$/.test(href)) return 'mailto:' + href;
    return href;
  }

  function phoneLink(value) {
    var label = String(value || '').trim();
    var dial = label.replace(/[\s().-]/g, '');
    return /^\+?\d{6,15}$/.test(dial) ? '<a href="tel:' + dial + '">' + esc(label) + '</a>' : esc(label);
  }

  function handelize(s) {
    return String(s).toLowerCase()
      .replace(/[^\w\u00C0-\u024f]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .split('\u00fc').join('ue');
  }

  var displayNames = null;
  try { displayNames = new Intl.DisplayNames([locale], { type: 'region' }); } catch (e) {}

  function countryName(code) {
    var c = String(code || '').toLowerCase();
    if (window.countries && window.countries[c]) return window.countries[c];
    if (displayNames) {
      try {
        var n = displayNames.of(c.toUpperCase());
        if (n && n !== c.toUpperCase()) return n;
      } catch (e) {}
    }
    return c.toUpperCase();
  }

  function regionLabel(name) {
    var h = handelize(name);
    return (window.regions && window.regions[h]) || name;
  }

  function updateStickies() {
    if (sticky.map)  try { sticky.map.updateSticky(); }  catch (e) {}
    if (sticky.menu) try { sticky.menu.updateSticky(); } catch (e) {}
  }


  var stores = [];        // {name, code, address, lat, lng, mapsUrl, phone, site, region, regionHandle}
  var countries = [];     // [{code, name, regions:[{name, handle, label}]}] posortowane po nazwie
  var countryIndex = {};  // code -> wpis z countries

  // Approved 12 October 2026: staged salon corrections; keep the shared feed unchanged.
  function damaApprovedSalonRow(source) {
    var key = String(source[1] || '').trim().toLowerCase() + '|' + String(source[0] || '').trim().toLowerCase();
    if (key === 'fr|belle en blanc' || key === 'au|brides by francesca') return null;
    var street = String(source[2] || '').split('\n')[0].trim().toLowerCase().replace(/ß/g, 'ss').replace(/[\s.]/g, '');
    var correction;
    if (key === 'de|brautmoden felice verleih und verkauf' && /^(ahornweg21|lennestr73|lennestrasse73)$/.test(street)) {
      correction = ['Lennestr. 73\n58762 Altena\nGermany', '51.2983489', '7.6738293'];
    } else if (key === 'ch|ivory - bridal boutique gmbh' && /^(kapuzinerstrasse25|gliserallee68)$/.test(street)) {
      correction = ['Gliserallee 68\n3902 Glis\nSwitzerland', '46.3142743', '7.9837173', 'https://maps.app.goo.gl/HhwBPwvUbwUxN3Tw8'];
    } else if (key === 'at|prinzessin brautmode' && /^(hauptstrasse9|hauptstrasse22)$/.test(street)) {
      correction = ['Hauptstrasse 22\n2603 Felixdorf\nAustria', '47.8826095', '16.2429559'];
    }
    if (key === 'it|yoliah spose' && /^(vialeluigicadorna18|viavarese19)$/.test(street)) {
      correction = ['Via Varese 19\n20020 Vanzaghello MI\nItaly', '45.5813833', '8.780051', 'https://www.google.com/maps/place/Yoliah/@45.5813833,8.780051,712m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47868c778126a7f1:0x3afded5109e11610!8m2!3d45.5813833!4d8.780051!16s%2Fg%2F11c75pykz3'];
    }
    if (!correction) return source;
    var row = source.slice();
    row[2] = correction[0]; row[3] = correction[1]; row[4] = correction[2];
    if (correction[3]) row[5] = correction[3];
    return row;
  }

  function parseRows(rows) {
    rows.forEach(function (r) {
      r = damaApprovedSalonRow(r);
      if (!r) return;
      if (locale === 'fr' && String(r[1] || '').trim().toLowerCase() === 'fr' && /^(confidence mariage|belle en blanc)$/i.test(String(r[0] || '').trim())) return;
      if (r[3] === undefined || r[4] === undefined) return;
      var lat = parseFloat(String(r[3]).replace(',', '.'));
      var lng = parseFloat(String(r[4]).replace(',', '.'));
      if (!isFinite(lat) || !isFinite(lng)) return;

      var region = '';
      if (r[8] !== undefined && String(r[8]).trim() !== '' && String(r[8]).trim() !== '-') {
        var parts = String(r[8]).split(')');
        region = parts[parts.length - 1].trim();
      }
      stores.push({
        name: r[0] || '',
        code: String(r[1] || '').trim().toLowerCase(),
        address: r[2] !== undefined ? String(r[2]) : '',
        lat: lat, lng: lng,
        mapsUrl: r[5] || '',
        phone: r[6] || '',
        site: r[7] || '',
        region: region,
        regionHandle: region ? handelize(region) : ''
      });
    });

    stores.forEach(function (s) {
      if (!s.code) return;
      var entry = countryIndex[s.code];
      if (!entry) {
        entry = countryIndex[s.code] = { code: s.code, name: countryName(s.code), regions: [], _rh: {} };
        countries.push(entry);
      }
      if (s.region && !entry._rh[s.regionHandle]) {
        entry._rh[s.regionHandle] = true;
        entry.regions.push({ name: s.region, handle: s.regionHandle, label: regionLabel(s.region) });
      }
    });
    countries.forEach(function (c) {
      delete c._rh;
      c.regions.sort(function (a, b) { return a.label.localeCompare(b.label, locale); });
    });
    countries.sort(function (a, b) { return a.name.localeCompare(b.name, locale); });
  }

  var PLUS_SVG = '<svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" class="icon icon--plus" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M0 8h18v2H0z"></path><path d="M10 0v18H8V0z"></path></g></svg>';

  // P09: count the complete existing card list, not only the active filter.
  var menuCountLabels = new WeakMap();

  function countMenuPoints(items, code, region) {
    return items.reduce(function (total, item) {
      var matches = code === 'all' ||
        (item.code === code && (!region || item.regionHandle === region));
      return total + (matches ? 1 : 0);
    }, 0);
  }

  function addListCounts(knownEmpty) {
    var cards = listEl.querySelectorAll('.stores__list-item');
    // A failed feed without retained cards is unknown, not a confirmed zero.
    if (!cards.length && !knownEmpty) return;
    var items = Array.prototype.map.call(cards, function (card) {
      return { code: card.dataset.country, regionHandle: card.dataset.region || '' };
    });
    menuEl.querySelectorAll('a[data-code], button[data-code]').forEach(function (el) {
      var label = Array.prototype.find.call(el.childNodes, function (node) {
        return node.nodeType === 3 && /\S/.test(node.nodeValue);
      });
      if (!label) return;
      if (!menuCountLabels.has(label)) menuCountLabels.set(label, label.nodeValue);
      var count = countMenuPoints(items, el.dataset.code, el.dataset.region || '');
      label.nodeValue = menuCountLabels.get(label).replace(/\s*$/, function (space) {
        return ' (' + count + ')' + space;
      });
    });
  }

  function buildMenu() {
    var html = '<li><a href="#all" data-code="all" class="stores__menu-item h2">' + esc(ALL) + '</a></li>';

    countries.forEach(function (c) {
      if (c.regions.length > 0) {
        var sub = '<ul class="stores__submenu">';
        /* punkt 8: "All" na gorze listy regionow = caly kraj */
        sub += '<li><a href="#' + esc(c.code) + '" data-code="' + esc(c.code) + '" data-all="1">' + esc(ALL) + '</a></li>';
        c.regions.forEach(function (r) {
          sub += '<li><a href="#' + esc(c.code) + '" data-code="' + esc(c.code) + '" data-region="' + esc(r.handle) + '" data-region-name="' + esc(r.name) + '">' + esc(r.label) + '</a></li>';
        });
        sub += '</ul>';
        html += '<li><button type="button" data-code="' + esc(c.code) + '" aria-expanded="false" class="stores__menu-item stores__menu-item--ancestor h2">' + esc(c.name) + ' ' + PLUS_SVG + '</button>' + sub + '</li>';
      } else {
        html += '<li><a href="#' + esc(c.code) + '" data-code="' + esc(c.code) + '" class="stores__menu-item h2">' + esc(c.name) + '</a></li>';
      }
    });
    menuEl.innerHTML = html;
  }

  function fillPopup() {
    var popupList = document.querySelector('#store-finder ul');
    var popupInfo = document.querySelector('#store-finder .richtext');
    if (popupList) {
      popupList.innerHTML = menuEl.innerHTML;
      popupList.querySelectorAll('.stores__menu-item').forEach(function (el) {
        el.classList.remove('stores__menu-item');
        el.classList.remove('h2');
        el.classList.add('popup__link');
      });
    }
    if (popupInfo && infoEl) popupInfo.innerHTML = infoEl.innerHTML;
  }

  function menuContainers() {
    var out = [menuEl];
    var p = document.querySelector('#store-finder ul');
    if (p) out.push(p);
    return out;
  }

  function setExpanded(btn, on) {
    btn.setAttribute('aria-expanded', on ? 'true' : 'false');
    var sub = btn.parentElement ? btn.parentElement.querySelector('.stores__submenu') : null;
    if (sub) sub.style.display = on ? 'block' : 'none';
  }

  function syncMenus() {
    menuContainers().forEach(function (container) {
      container.querySelectorAll('.stores__menu-item--active').forEach(function (el) {
        el.classList.remove('stores__menu-item--active');
      });
      container.querySelectorAll('.stores__submenu a.active').forEach(function (el) {
        el.classList.remove('active');
      });
      container.querySelectorAll('button[data-code]').forEach(function (btn) {
        setExpanded(btn, btn.dataset.code === state.code);
      });
      var top = container.querySelector('a[data-code="' + state.code + '"]:not([data-region]):not([data-all]), button[data-code="' + state.code + '"]');
      if (top) top.classList.add('stores__menu-item--active');

      if (state.region) {
        var r = container.querySelector('a[data-code="' + state.code + '"][data-region="' + state.region + '"]');
        if (r) r.classList.add('active');
      } else {
        var a = container.querySelector('a[data-code="' + state.code + '"][data-all]');
        if (a) a.classList.add('active');
      }
    });
    updateStickies();
  }

  function buildList() {
    var html = '';
    stores.forEach(function (s, i) {
      var site = siteLabel(s.site);
      html += '<div class="stores__list-item" data-idx="' + i + '" data-country="' + esc(s.code) + '" data-region="' + esc(s.regionHandle) + '">'
        + '<div class="richtext">'
        + '<p><strong>' + esc(s.name) + '</strong></p>'
        + '<p>' + esc(s.address).split('\n').join('<br>') + '</p>'
        + (s.phone ? '<p>' + phoneLink(s.phone) + '</p>' : '')
        + (s.site ? '<p><a href="' + esc(siteHref(s.site)) + '" target="_blank" rel="noopener noreferrer nofollow">' + esc(site) + '</a></p>' : '')
        + '</div></div>';
    });
    listEl.innerHTML = html;
  }

  function renderList() {
    listEl.querySelectorAll('.stores__list-item').forEach(function (el) {
      var show = state.code === 'all'
        || (el.dataset.country === state.code && (!state.region || el.dataset.region === state.region));
      el.style.display = show ? 'block' : 'none';
    });
  }

  function updateLabels() {
    var label = state.code === 'all' ? ALL
      : state.region ? (countryName(state.code) + ' (' + regionLabel(state.regionName) + ')')
      : countryName(state.code);
    document.querySelectorAll('[data-current-country]').forEach(function (el) { el.textContent = label; });
  }

  var state = { code: 'all', region: null, regionName: '' };
  var suppressHash = false;

  function parseHash() {
    var raw = (location.hash || '').replace('#', '').toLowerCase();
    if (!raw) return null;
    if (raw === 'all') return 'all';
    return countryIndex[raw] ? raw : null;
  }

  function applySelection(code, region, regionName) {
    state.code = code;
    state.region = region || null;
    state.regionName = regionName || '';
    if (iw) iw.close();
    syncMenus();
    renderList();
    updateLabels();
    fitMap();
  }

  function userNavigate(code, region, regionName, fromPopup) {
    if ('#' + code !== location.hash) {
      suppressHash = true;
      location.hash = code;
    }
    applySelection(code, region, regionName);
    if (fromPopup) {
      var close = document.querySelector('#store-finder [data-popup-close]');
      if (close) close.click();
    }
  }

  window.addEventListener('hashchange', function () {
    if (suppressHash) { suppressHash = false; return; }
    applySelection(parseHash() || 'all', null, '');
  });

  function handleGlobalClick(e) {
    if (e.__sfHandled) return;
    e.__sfHandled = true;
    var inFinder = e.target.closest('.stores-v2');
    var inPopup  = e.target.closest('#store-finder');
    if (!inFinder && !inPopup) return;

    var btn = e.target.closest('button[data-code]');
    if (btn && (btn.classList.contains('stores__menu-item--ancestor') || btn.classList.contains('popup__link'))) {
      var container = btn.closest('#store-finder ul') || menuEl;
      var expand = btn.getAttribute('aria-expanded') !== 'true';
      container.querySelectorAll('button[data-code]').forEach(function (b) { setExpanded(b, false); });
      setExpanded(btn, expand);
      updateStickies();
      return;
    }

    var a = e.target.closest('a[data-code]');
    if (a) {
      e.preventDefault();
      var region = a.hasAttribute('data-region') ? a.dataset.region : null;
      userNavigate(a.dataset.code, region, a.dataset.regionName || '', !!inPopup);
      return;
    }

    var li = e.target.closest('.stores__list-item');
    if (li && !e.target.closest('a')) focusStore(parseInt(li.dataset.idx, 10));
  }

  document.addEventListener('click', handleGlobalClick);
  (function () {
    var popupUl = document.querySelector('#store-finder ul');
    if (popupUl) popupUl.addEventListener('click', handleGlobalClick);
  })();

  var map = null, markers = [], iw = null, projReady = false, pendingFit = false;

  function whenMapsReady(cb) {
    var done = false;
    function fire() { if (done) return; done = true; cb(); }
    if (window.google && google.maps && google.maps.Map) return fire();
    var prev = window.initMap;
    window.initMap = function () {
      if (prev) try { prev(); } catch (e) {}
      fire();
    };
    var iv = setInterval(function () {
      if (window.google && google.maps && google.maps.Map) { clearInterval(iv); fire(); }
    }, 200);
  }

  function armLazyMap() {
    if (!('IntersectionObserver' in window)) { whenMapsReady(initMap2); return; }
    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (en) { return en.isIntersecting; })) {
        io.disconnect();
        whenMapsReady(initMap2);
      }
    }, { rootMargin: '300px 0px' });
    io.observe(mapWrap);
  }

  function initMap2() {
    if (map) return;
    map = new google.maps.Map(mapEl, {
      zoom: 4,
      center: new google.maps.LatLng(50.53029993514656, 14.987954178933542),
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      styles: [{"featureType":"all","elementType":"geometry.fill","stylers":[{"color":"#e0d3b8"}]},{"featureType":"all","elementType":"labels.text.fill","stylers":[{"color":"#5a554a"}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"color":"#f7f4f0"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#b5a27f"}]},{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#141432"}]},{"featureType":"administrative","elementType":"labels.text.stroke","stylers":[{"visibility":"off"}]},{"featureType":"landscape.natural","elementType":"geometry.fill","stylers":[{"color":"#e0d3b8"}]},{"featureType":"landscape.man_made","elementType":"geometry.fill","stylers":[{"color":"#edeae6"}]},{"featureType":"poi","elementType":"geometry.fill","stylers":[{"color":"#e5e2de"}]},{"featureType":"poi","elementType":"labels","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"geometry.fill","stylers":[{"color":"#c7c4c0"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#5a554a"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#f7f4f0"}]},{"featureType":"road","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#c7c4c0"},{"weight":1.8}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#efe7d8"}]},{"featureType":"water","elementType":"labels","stylers":[{"visibility":"off"}]}]
    });

    var icon = {
      url: window.markerImg,
      scaledSize: new google.maps.Size(PIN_W, PIN_H),
      anchor: new google.maps.Point(PIN_W / 2, PIN_H)
    };

    stores.forEach(function (s, i) {
      var m = new google.maps.Marker({
        position: new google.maps.LatLng(s.lat, s.lng),
        icon: icon,
        title: s.name,
        map: null
      });
      m.addListener('click', function () { openBubble(i); document.dispatchEvent(new CustomEvent('dama:finder-marker-selected', { detail: { storeIndex: i } })); });
      markers.push(m);
    });

    iw = new google.maps.InfoWindow();
    map.addListener('click', function () { iw.close(); });

    google.maps.event.addListenerOnce(map, 'idle', function () {
      projReady = true;
      recluster();
    });
    map.addListener('zoom_changed', debounce(recluster, 150));

    if (pendingFit) fitMap();
  }

  function openBubble(i) {
    var s = stores[i], m = markers[i];
    if (!map || !iw) return;
    var site = siteLabel(s.site);
    var viewMap = (window.accessibility && window.accessibility.viewMap) || 'View full map';
    var header = document.createElement('p');
    header.className = 'dama-finder-bubble-title';
    header.textContent = s.name;
    var html = '<div class="stores__bubble">'
      + '<div class="richtext richtext--small">'
      + '<p>' + esc(s.address).split('\n').join('<br>') + '</p>'
      + (s.phone ? '<p class="no-margin">' + phoneLink(s.phone) + '</p>' : '')
      + (s.site ? '<p><a href="' + esc(siteHref(s.site)) + '" target="_blank" rel="noopener noreferrer nofollow">' + esc(site) + '</a></p>' : '')
      + '</div>'
      + (s.mapsUrl ? '<div class="stores__bubble-buttons"><a href="' + esc(s.mapsUrl) + '" target="_blank" rel="noopener noreferrer nofollow" class="dama-finder-map-link">' + esc(viewMap) + '</a></div>' : '')
      + '</div>';
    iw.setOptions({
      maxWidth: Math.min(320, Math.max(220, mapEl.clientWidth - 48)),
      ariaLabel: s.name,
      headerContent: header
    });
    iw.setContent(html);
    if (m.getMap() !== map) m.setMap(map);
    iw.open({ anchor: m, map: map });
  }

  function focusStore(i) {
    var s = stores[i];
    if (!s) return;
    var run = function () {
      map.panTo(new google.maps.LatLng(s.lat, s.lng));
      map.setZoom(17);
      setTimeout(function () { openBubble(i); }, 220);
      if (window.matchMedia('(max-width: 1023px)').matches) {
        mapWrap.scrollIntoView({ behavior: 'smooth' });
      }
    };
    if (map) run(); else whenMapsReady(function () { initMap2(); run(); });
  }

  function boundsOf(list) {
    var b = new google.maps.LatLngBounds();
    list.forEach(function (s) { b.extend(new google.maps.LatLng(s.lat, s.lng)); });
    return b;
  }

  function fitWithCap(b, cap) {
    map.setOptions({ maxZoom: cap });
    map.fitBounds(b, 40);
    var release = function () { map.setOptions({ maxZoom: null }); };
    google.maps.event.addListenerOnce(map, 'idle', release);
    setTimeout(release, 800); /* gdy fitBounds nie zmieni widoku, 'idle' nie strzeli */
  }

  function fitMap() {
    if (!map) { pendingFit = true; return; }
    pendingFit = false;

    if (state.code === 'all') {
      map.setOptions({ maxZoom: null });
      map.fitBounds(new google.maps.LatLngBounds(
        new google.maps.LatLng(34, -25), new google.maps.LatLng(71, 45)
      ));
      return;
    }

    if (state.region) {
      var rs = stores.filter(function (s) { return s.code === state.code && s.regionHandle === state.region; });
      if (rs.length) fitWithCap(boundsOf(rs), 10);
      return;
    }

    var boundary = null;
    (window.boundaries || []).forEach(function (b) { if (b.country === state.code) boundary = b; });
    if (boundary) {
      map.setOptions({ maxZoom: null });
      var b = new google.maps.LatLngBounds();
      b.extend(new google.maps.LatLng(boundary.start.lat, boundary.start.lng));
      b.extend(new google.maps.LatLng(boundary.end.lat, boundary.end.lng));
      map.fitBounds(b);
      return;
    }
    /* fallback dla krajow bez wpisu w window.boundaries (np. nowe kraje z arkusza) */
    var cs = stores.filter(function (s) { return s.code === state.code; });
    if (cs.length) fitWithCap(boundsOf(cs), 10);
  }



  var clusterMarkers = [];

  function clusterIcon(n) {
    var r = n < 10 ? 18 : n < 50 ? 21 : 24;
    var s = r * 2 + 4;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="' + s + '" height="' + s + '">'
      + '<circle cx="' + (s / 2) + '" cy="' + (s / 2) + '" r="' + r + '" fill="#141432" stroke="#ffffff" stroke-width="2"/></svg>';
    return {
      url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg),
      scaledSize: new google.maps.Size(s, s),
      anchor: new google.maps.Point(s / 2, s / 2),
      labelOrigin: new google.maps.Point(s / 2, s / 2 - 1)
    };
  }

  function recluster() {
    if (!map || !projReady) return;
    clusterMarkers.forEach(function (m) { m.setMap(null); });
    clusterMarkers = [];

    var zoom = map.getZoom();
    if (zoom >= CLUSTER_MAX_ZOOM) {
      markers.forEach(function (m) { if (m.getMap() !== map) m.setMap(map); });
      return;
    }
    var proj = map.getProjection();
    if (!proj) return;

    var scale = Math.pow(2, zoom);
    var cells = {};
    markers.forEach(function (m, i) {
      var p = proj.fromLatLngToPoint(m.getPosition());
      var key = Math.floor(p.x * scale / CLUSTER_GRID_PX) + '_' + Math.floor(p.y * scale / CLUSTER_GRID_PX);
      (cells[key] = cells[key] || []).push(i);
    });

    Object.keys(cells).forEach(function (k) {
      var idx = cells[k];
      if (idx.length === 1) {
        var m = markers[idx[0]];
        if (m.getMap() !== map) m.setMap(map);
        return;
      }
      var lat = 0, lng = 0;
      idx.forEach(function (i) {
        markers[i].setMap(null);
        var p = markers[i].getPosition();
        lat += p.lat(); lng += p.lng();
      });
      lat /= idx.length; lng /= idx.length;

      var cm = new google.maps.Marker({
        position: new google.maps.LatLng(lat, lng),
        map: map,
        icon: clusterIcon(idx.length),
        label: { text: String(idx.length), color: '#ffffff', fontSize: '13px', fontWeight: '500', fontFamily: '"EB Garamond", Georgia, serif' },
        zIndex: google.maps.Marker.MAX_ZINDEX + 1
      });
      cm.addListener('click', function () {
        var b = new google.maps.LatLngBounds();
        idx.forEach(function (i) { b.extend(markers[i].getPosition()); });
        map.fitBounds(b, 60);
        google.maps.event.addListenerOnce(map, 'idle', function () {
          if (map.getZoom() > 17) map.setZoom(17);
        });
      });
      clusterMarkers.push(cm);
    });
  }

  var sticky = { map: null, menu: null };
  var mq1024 = window.matchMedia('(min-width: 1024px)');

  function setupSticky() {
    if (typeof StickySidebar === 'undefined') return;
    if (mq1024.matches) {
      if (!sticky.map && document.querySelector('.stores__map-inner')) {
        sticky.map = new StickySidebar('.stores__map-inner', { topSpacing: 70, bottomSpacing: 0 });
      }
      if (!sticky.menu && document.querySelector('.stores__menu-inner')) {
        sticky.menu = new StickySidebar('.stores__menu-inner', { topSpacing: 30, bottomSpacing: 0 });
      }
    } else {
      if (sticky.map)  { try { sticky.map.destroy(); }  catch (e) {} sticky.map = null; }
      if (sticky.menu) { try { sticky.menu.destroy(); } catch (e) {} sticky.menu = null; }
    }
  }
  if (mq1024.addEventListener) mq1024.addEventListener('change', setupSticky);
  else if (mq1024.addListener) mq1024.addListener(setupSticky);

  if ('ResizeObserver' in window) {
    new ResizeObserver(debounce(updateStickies, 150)).observe(root);
  }

  function detectCountry() {
    return new Promise(function (resolve) {
      var settled = false;
      var t = setTimeout(function () { settled = true; resolve(null); }, GEO_TIMEOUT_MS);
      var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      try {
        fetch(base + 'browsing_context_suggestions.json')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            if (settled) return;
            clearTimeout(t);
            var h = j && j.detected_values && j.detected_values.country && j.detected_values.country.handle;
            resolve(h ? String(h).toLowerCase() : null);
          })
          .catch(function () { if (!settled) { clearTimeout(t); resolve(null); } });
      } catch (e) { clearTimeout(t); resolve(null); }
    });
  }

  var geoPromise = (location.hash || '').length > 1 ? Promise.resolve(null) : detectCountry();

  fetch(SHEET_URL, { headers: { 'Content-Type': 'application/json' } })
    .then(function (r) {
      if (!r.ok) throw new Error('Store finder data request failed');
      return r.json();
    })
    .then(function (json) {
      if (!json || !Array.isArray(json.values) || !json.values.every(Array.isArray)) {
        throw new Error('Store finder data response is invalid');
      }
      var rows = json.values;
      rows.shift(); /* naglowki */
      parseRows(rows);
      buildMenu();
      buildList();
      addListCounts(true);
      fillPopup();

      var fromHash = parseHash();
      if (fromHash) {
        finishBoot(fromHash);
        return;
      }
      geoPromise.then(function (geo) {
        var code = (geo && countryIndex[geo]) ? geo : 'all';
        if (history.replaceState) {
          history.replaceState(null, document.title, location.pathname + location.search + '#' + code);
        }
        finishBoot(code);
      });
    })
    .catch(function () {
      // Keep the server-rendered list and use its existing country menu.
      stores = [];
      countries = [];
      countryIndex = {};
      menuEl.querySelectorAll('[data-code]').forEach(function (el) {
        var code = el.dataset.code;
        if (code && code !== 'all') countryIndex[code] = { code: code };
      });
      addListCounts(false);
      fillPopup();
      // Server-rendered cards have no coordinates; do not create an empty map.
      finishBoot(parseHash() || 'all', false);
    });

  function finishBoot(code, enableMap) {
    applySelection(code, null, '');
    root.classList.remove('stores-v2--loading');
    setupSticky();
    if (enableMap !== false) armLazyMap();
  }
})();

